






import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class Toast extends Vue {
  @Prop({ default: false, type: Boolean })
  show!: boolean;

  @Prop(String) text!: string;

  @Prop({
    type: String,
    validator: value => {
      return ["success", "info", "error", "warning"].indexOf(value) !== -1;
    }
  })
  type!: string;
}
